// extracted by mini-css-extract-plugin
export var container = "_dx-0";
export var segment = "_dx-2";
export var segmentActive = "_dx-3";
export var track = "_dx-1";